// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { billingAddressStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsBillingAddress";
import { styledBoxStyle } from "@keller/App/Components/Common/StyledBox";
import xOrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import { color, hideElement, mergeWithCss, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

billingAddressStyles.headerText = {
    css: css`
        ${hideElement}
    `,
};

billingAddressStyles.titleText = {
    ...mergeWithCss(xOrderInformationStyles.address?.heading, {
        css: css`
            @media print {
                background-color: ${color("common.white")};
                border: 1px solid ${color("common.border")};
                border-bottom: 0;
                font-size: 12px;
                line-height: 18px;
                padding: 8px;
                margin: 0;
            }
        `,
    }),
};

billingAddressStyles.wrapper = {
    css: css`
        flex-direction: column;
        width: 100%;

        address {
            width: 100%;
            border-radius: 4px;
            margin-bottom: 10px;
            min-height: 100px;
            ${styledBoxStyle}

            ${xScreen("lte", "md")} {
                margin-bottom: 0;
            }

            @media print {
                border-radius: 0;
                padding: 8px;
                flex-grow: 1;
            }
        }
        @media print {
            display: flex;
            height: 100%;
        }
    `,
};
